'use client'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { useState } from 'react'

import { useClearQueryCacheOnUserChange } from '@/lib/query/clear-on-user-change'
import { STALE_TIME } from '@/lib/query/stale-times'

// A child so the hook runs under QueryClientProvider (and inside the
// ClerkProvider that wraps this provider in `app/layout.tsx`).
function ClearQueryCacheOnUserChange() {
  useClearQueryCacheOnUserChange()
  return null
}

export default function TanstackProvider({ children }: any) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // School data doesn't change frequently, so longer stale times are appropriate
            staleTime: STALE_TIME.standard, // 2 minutes
            // Network issues are common in school environments, so retries make sense
            retry: 3,
            // Keep data fresh when users return to tabs
            refetchOnWindowFocus: true,
            // Ensure fresh data on component mount
            refetchOnMount: true,
            // Sync data when connection returns
            refetchOnReconnect: true,
            // Cache data for 10 minutes to reduce server load
            gcTime: 10 * 60 * 1000, // 10 minutes
            // Handle offline scenarios gracefully
            networkMode: 'online'
          },
          mutations: {
            // Disable retries for user-initiated actions (posts, forms) for immediate feedback
            retry: false,
            // Handle offline scenarios gracefully
            networkMode: 'online'
          }
        }
      })
  )

  return (
    <QueryClientProvider client={queryClient}>
      <ClearQueryCacheOnUserChange />
      {children}
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  )
}
